<template>
    <div>
        <rs-table
            :data="rolesTableData"
            highlight-current-row
            class="my-table-auth"
            tooltip-effect="light"
            border
            style="width: 100%;">
            <rs-table-column label="角色名称" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="color:#0091FF;">{{scope.row.roleName}}</span>
                </template>
            </rs-table-column>
            <rs-table-column
                label="授权时间"
                prop="createTime"
                show-overflow-tooltip
                align="left">
            </rs-table-column>
            <rs-table-column
                label="是否授权"
               
                align="left">
                <template slot-scope="scope">
                    <!-- <rs-button @click="remove(scope.row)" type="text" size="small">移除</rs-button> -->
                    <rs-switch @change="remove(scope.row)"   v-model="scope.row.type"></rs-switch>
                </template>
            </rs-table-column>
        </rs-table>
    </div>
</template>

<script>
import userApi from '@/api/account'
export default {
    data() {
        return {
            userId: '',
            // 角色表单
            roleForm: {
                roles: ''
            },
            roleRules: {},
            rolesTableData: []
        }
    },
    props: {
        userCode: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 移除角色权限
        remove(row) {
            console.log(row.type);
            if(!row.type){
            let params = {
                "roleId": row.roleId,
                "userId": this.userId,
            }
            userApi.setUnbindRole(params).then(res=>{
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                });
                this.handleRoles()
                this.updateStoreGroupUser()
            })
            }else if(row.type){
                this.submitRoles(row.roleId)
            }
        },
        // 获取用户角色权限
        handleRoles() {
            userApi.queryRolesAuth(this.userId).then(res=>{
                this.rolesTableData = res.data.data
                 this.rolesTableData.forEach(item=>{
                     if(item.type == 1) item.type =true
                     else if(item.type == 0) item.type =false
                 })
            })
           
        },
        // 同步账号
        updateStoreGroupUser() {
            userApi.updateStoreGroupUser({userCode: this.userCode})
        },
        // // 添加角色权限
        // handleRole() {
        //     this.roleForm.roles = ''
        //     this.$dialogManage({
        //         width: '543px',
        //         title: '添加角色',
        //         formData: this.roleForm,
        //         rules: this.roleRules,
        //         type: 'roleBindForm',
        //         className: 'form-dialog add-form-dialog',
        //         btnText: '确定授权'
        //     }).then(data => {
        //         let form = data
        //         // form.parentOrgSysCode = data.parentOrgSysCode[0]
        //         console.log(form);
        //         this.submitRoles(form)
        //     })
        // },
        // dialog事件
        submitRoles(data) {
            let params = {
                "roleId": data,
                "userId": this.userId,
            }
            userApi.setBindRole(params).then(res=>{
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                });
                this.handleRoles()
                this.updateStoreGroupUser()
            }).catch(err=>{
                // this.$message({
                //     message: '操作成功！',
                //     type: 'error'
                // });
            })
        },
    },
    //生命周期 - 创建完成（访问当前this实例）
    created() {
        this.userId = this.$route.query.id
        this.handleRoles()
    },
    //生命周期 - 挂载完成（访问DOM元素）
    mounted() {
}
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add-role-button {
    padding: 0!important;
    margin-bottom: 10px;
    height: 20px!important;
}
</style>